export const getKeyStorageItems = payload => {
    return {
        type: "GET_KEY_STORAGE_ITEMS",
        payload: payload
    }
}